import { faker } from '@faker-js/faker';
import React from 'react';

export interface IData {
  name: string;
  rate: string;
}

export function useQuery() {


  return React.useMemo(
    () => {
      const data: IData[] = [
        ...__generateMonthlyPrices('Jan'),
        ...__generateMonthlyPrices('Feb'),
        ...__generateMonthlyPrices('Mar'),
        ...__generateMonthlyPrices('Apr'),
        ...__generateMonthlyPrices('May'),
        ...__generateMonthlyPrices('Jun'),
        ...__generateMonthlyPrices('Jul'),
        ...__generateMonthlyPrices('Aug'),
        ...__generateMonthlyPrices('Sep'),
        ...__generateMonthlyPrices('Oct'),
        ...__generateMonthlyPrices('Nov'),
        ...__generateMonthlyPrices('Dec')
      ];

      return {
        data
      };
    },
    []
  );
}


const __generateMonthlyPrices = (month: string) => {
  return [
    {
      name: `${month}-1`,
      rate: faker.number.float({
        min: 0.2, max: 2
      }).toFixed(2),
      relativeRate: faker.number.float({
        min: 0.2, max: 2
      }).toFixed(2)
    },
    {
      name: `${month}-14`,
      rate: faker.number.float({
        min: 0.2, max: 2
      }).toFixed(2),
      relativeRate: faker.number.float({
        min: 0.2, max: 2
      }).toFixed(2)
    },
    {
      name: `${month}-21`,
      rate: faker.number.float({
        min: 0.2, max: 2
      }).toFixed(2),
      relativeRate: faker.number.float({
        min: 0.2, max: 2
      }).toFixed(2)
    },
    {
      name: `${month}-30`,
      rate: faker.number.float({
        min: 0.2, max: 2
      }).toFixed(2),
      relativeRate: faker.number.float({
        min: 0.2, max: 2
      }).toFixed(2)
    }
  ];
};
